import { connect } from 'react-redux';
import { actions, selectors } from 'app-webtech-core';
import { loadedData } from 'app-modules/trivia/selectors';
import { isCCEnabledSelector } from 'app-modules/player/selectors/isCCEnabled';
import { properties as embedSelector } from 'app-modules/embed/selectors';
import { ChannelOverlay } from '../components/ChannelOverlay';
import { checkMobileOperatingSystem } from '../../application/utils/checkMobileOperatingSystem';
import {
  toggleCaption,
  ccSetSetting,
  internalResetCaptionsSettings,
  exitFullscreen,
  enterFullscreen,
} from '../actions';
import parse from 'url-parse';
import { getCurrentShow } from '../../../utils';

const mapStateToProps = (state) => {
  const { mute: isMuted } = selectors.player.properties(state);
  const { isMobile } = checkMobileOperatingSystem();
  const content = selectors.player.content(state);
  const podProperties = selectors.podTrackerAds.properties(state);
  const triviaData = loadedData(state);
  const { captionInUseIndex, captionList } = state.playerinternal;
  const embedState = embedSelector(state);
  const isEmbed = embedState.enabled || embedState.corpEmbed;
  const channel = content ? content.raw : {};
  const nowPlaying = getCurrentShow(channel);
  const episode = nowPlaying && nowPlaying.episode;
  const episodeRating = episode && episode.rating;
  const isRatingImage = selectors.rating.isRatingImage(state)(episodeRating);
  let rating = selectors.rating.getRating(state)(episodeRating);

  if (isRatingImage) {
    const parsedRatingImage = parse(rating);
    parsedRatingImage.set('query', '?w=20&h=20');
    rating = parsedRatingImage.toString();
  }
  return {
    channel,
    isTrivia: !!triviaData,
    showVideoControls: !podProperties.currentPlayingAd,
    haveCaptions: captionList.length > 0,
    captionIndex: captionInUseIndex,
    isMuted,
    isEmbed,
    isCCEnabled: isCCEnabledSelector(state),
    isFullscreenDisabled: isMobile,
    nowPlaying,
    episode,
    isRatingImage,
    rating,
  };
};

const mapDispatchToProps = {
  toggleCaption,
  onCCSettingsChange: ccSetSetting,
  resetCCSettings: internalResetCaptionsSettings,
  exitFullscreen,
  enterFullscreen,
  ccMenuClose: actions.player.ccMenuClose,
};

export const ChannelOverlayContainer = connect(mapStateToProps, mapDispatchToProps)(ChannelOverlay);
